module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am763-46061a205299215d345016ccae53864f.jpg";